import { Component, OnInit, Input, inject } from '@angular/core';
import { AuthenticationService, AppService } from '@lc/core';
import { MatButton } from '@angular/material/button';
import { CookieService } from '@lc/core/lib/services/cookie.service';
import { E2eIdDirective } from '@lc/ui';

@Component({
  selector: 'lc-inactivity-logout',
  templateUrl: './inactivity-logout.component.html',
  styleUrls: ['./inactivity-logout.component.scss'],
  imports: [MatButton, E2eIdDirective],
})
export class InactivityLogoutComponent implements OnInit {
  authService = inject(AuthenticationService);
  private readonly cookieService = inject(CookieService);

  @Input() title: string;

  readonly appName: string = this.cookieService.getCookie('app') || AppService.get('applicationName');

  async ngOnInit() {
    await this.authService.logout();
  }

  login() {
    this.authService.redirectToLogin();
  }
}
